import { render, staticRenderFns } from "./PromotionPcMembers.vue?vue&type=template&id=785ed212&"
import script from "./PromotionPcMembers.vue?vue&type=script&lang=js&"
export * from "./PromotionPcMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports